export default __webpack_public_path__ + "static/media/ky.63d8f295.svg";